import styled from 'styled-components';

// Dashboard X/Twitter — superficie unica escura dividida por hairlines.
// Sem cards arredondados nem sombras.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: 0 0 0 64px;
  box-sizing: border-box;
  background: var(--cco-bg);
  color: var(--cco-ink);

  @media (max-width: 1300px) {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  /* No mobile o rail (64px) some — remove o padding-left. */
  @media (max-width: 720px) {
    padding-left: 0;
  }

  .google-api-wrapper > div {
    width: 100% !important;
  }
`;

// Wrapper do shell: container interno do main com borda externa hairline
// + sections separadas por border-top. Grid em 2 linhas pra dar altura
// explicita pras sections (sem isso o mapa colapsa).
export const Main = styled.div`
  flex: 1;
  display: grid;
  grid-template-rows: 1fr auto;
  min-width: 0;
  min-height: 0;
  background: var(--cco-bg);
  border: 1px solid var(--cco-line);
  border-radius: 0;

  > section + section {
    border-top: 1px solid var(--cco-line);
  }
`;

// ──────────────────────────────────────────────────────────────────
// Mobile (<=720px) tab nav — Alertas / Mapa / Visao Geral. Substitui
// o scroll vertical das 3 secoes empilhadas (que sobrepunham e
// competiam por espaco) por foco numa de cada vez.
// ──────────────────────────────────────────────────────────────────
export const MobileTabBar = styled.nav`
  display: none;
  @media (max-width: 720px) {
    display: flex;
    align-items: stretch;
    width: 100%;
    border-bottom: 1px solid var(--cco-line);
    background: var(--cco-bg);
  }
`;

export const MobileTabBtn = styled.button`
  flex: 1;
  padding: 12px 6px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid
    ${(props) => (props.$active ? 'var(--cco-blue)' : 'transparent')};
  color: ${(props) =>
    props.$active ? 'var(--cco-blue)' : 'var(--cco-ink-mute)'};
  font-family: inherit;
  font-size: var(--fs-label);
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  text-transform: none;
  transition: color 0.15s, border-color 0.15s;
  /* badge inline pra contagem (ex.: Alertas (3)) */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;

  > .ct {
    display: inline-grid;
    place-items: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 999px;
    background: var(--cco-red);
    color: #fff;
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
  }
`;

// Wrapper das 3 panels mobile — visibility controlada pelo tab atual.
// Map fica sempre montado (mesmo invisivel) pra preservar polling/state
// dos markers; quando volta a ser visivel, google-maps re-renderiza
// ao detectar resize do container.
export const MobilePanel = styled.div`
  display: ${(props) => (props.$active ? 'flex' : 'none')};
  flex-direction: column;
  width: 100%;
`;

// Wrapper do mapa em mobile — mantem montado o tempo todo, mas com
// height/visibility controlados pelo tab pra nao "vazar" pra outras
// abas (especialmente pq google-maps usa containers absolutos).
export const MobileMapWrapper = styled.div`
  width: 100%;
  /* Quando inativo, container some sem unmount pra preservar o map
     instance + polling. Heigh fixa quando ativo. */
  ${(props) =>
    props.$active
      ? 'height: calc(100vh - 110px); min-height: 400px;'
      : 'height: 0; overflow: hidden;'}
`;

// Top row: wrapper que da altura pro pracas-mapa renderizar seu
// proprio grid 3-col (filtros 380 | mapa 1fr | alertas 360). Nao
// duplica o grid aqui pra evitar conflito (mapa colapsava em 380px
// quando TopRow tinha 3-col mas so 1 filho).
export const TopRow = styled.section`
  display: flex;
  min-height: 520px;
  min-width: 0;
  overflow: hidden;

  > * {
    flex: 1;
    min-width: 0;
  }
`;

// Bottom row: 2 metades (UCHAs | EBAs) com hairline vertical entre elas.
export const BottomRow = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 380px;
  min-width: 0;

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1300px) {
    grid-template-columns: 1fr;
    > * + * {
      border-left: none;
      border-top: 1px solid var(--cco-line);
    }
  }
`;

// Wrapper legado mantido pra compat — usado no fallback mobile do
// dashboard.js. Hairline-divided em vez de gap.
export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: space-between;
  gap: 0;
  ${(props) => props.column && 'flex-direction: column; align-items: stretch;'};

  > * + * {
    ${(props) =>
      props.column
        ? 'border-top: 1px solid var(--cco-line); border-left: none;'
        : 'border-left: 1px solid var(--cco-line); border-top: none;'}
  }
`;

// Card legado — mantido pra compat com fallback mobile. Sem borda
// individual (a borda agora vive no Main container).
export const Card = styled.div`
  display: flex;
  width: ${(props) => props.width || '100%'};
  ${(props) => props.height && `height: ${props.height};`}
  ${(props) => props.flex && `flex: ${props.flex};`}
  background: transparent;
  overflow: hidden;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  box-sizing: border-box;
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'unset')};
  border: none;
  min-height: 0;
`;
